//online appointment api

import axios from "axios";
import API_BASE_URL from "../BaseURL/baseURL";
import axiosInstance from "../BaseURL/axiosInstance";

export const fetchtimeslab = async (pde_id) => {
  const response = await fetch(
    `${API_BASE_URL}/OnlineAppointment/Appointment_Select_Time_Slab?PDEid=${pde_id}`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchSROs = async (pde, AppointmentDate, selectedSlab) => {
  //debugger;

  const response = await fetch(
    `${API_BASE_URL}/OnlineAppointment/Appointment_Select_Time_Slab_Appointment?PDEid=${pde}&Appointmentdate=${AppointmentDate}&timeslab=${selectedSlab}&appointment_type=N`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchBookSROAppointment = async (payload, mode) => {
  try {
    const endpoint =
      mode === "modify"
        ? "/OnlineAppointment/UPDATE_PDEID_appointment_STATUS_modify"
        : "/OnlineAppointment/UPDATE_PDEID_appointment_STATUS";

    const response = await axiosInstance.post(endpoint, payload);

    if (response.status === 200) {
      console.log("Appointment API success:", response);
      return response;
    } else {
      throw new Error("Appointment API failed");
    }
  } catch (error) {
    console.error("Appointment API error:", error);
    throw error;
  }
};
